// ScanSelection.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLoading } from '../utils/loading/LoadingContext';
import LoadingIndicator from '../utils/loading/LoadingIndicator';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const PalletScanSelection = () => {
  const [pallets, setPallets] = useState([]);
  const { isLoading, setLoading } = useLoading();
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_DJANGO_API_BASE_URL;  // Make sure to set this correctly in your environment

  // Fetch pallets from the backend
  useEffect(() => {
    fetchPallets();
  }, []);

  const fetchPallets = () => {
    setLoading(true);
    fetch(`${baseUrl}/api/pallet_scan_selection/`, {
      headers: {
        'Accept': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setPallets(data.pallets);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching pallets:', error);
        toast.error('Failed to load pallets');
        setLoading(false);
      });
  };

  // Redirect the user to the pallet creation page
  const createPallet = () => {
    setLoading(true);
    fetch(`${baseUrl}/api/create_new_pallet/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    })
      .then((response) => response.json())
      .then((data) => {
        toast.success(`New pallet created: ${data.pallet_number}`);
        setPallets(data.pallets); // Update the pallet list
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error creating pallet:', error);
        toast.error('Failed to create a new pallet');
        setLoading(false);
      });
  };

  // Navigate to the scan or remove page using base URL redirection
  const handleScan = (palletNumber) => {
    navigate(`/pallet-scan-selection/${palletNumber}/scan`);  // Redirect to scan page
  };

  const handleRemove = (palletNumber) => {
    navigate(`/pallet-scan-selection/${palletNumber}/remove`);  // Redirect to remove page
  };

  return (
    <div className="scan-selection-body">
      {isLoading && <LoadingIndicator />}
      <h2>Select or Create a Pallet</h2>

      <button className="create-pallet-btn" onClick={createPallet}>
        Create New Pallet
      </button>

      <h3>Available Pallets</h3>
      {pallets.length > 0 ? (
        <table className="pallets-table">
          <thead>
            <tr>
              <th>Pallet Number</th>
              <th>Created At</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {pallets.map((pallet) => (
              <tr key={pallet.pallet_number}>
                <td>{pallet.pallet_number}</td>
                <td>{new Date(pallet.created_at).toLocaleString()}</td>
                <td>
                  <button
                    className="scan-btn"
                    onClick={() => handleScan(pallet.pallet_number)}
                  >
                    Scan into this Pallet
                  </button>
                  <button
                    className="remove-btn"
                    onClick={() => handleRemove(pallet.pallet_number)}
                  >
                    Remove from this Pallet
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No available pallets found.</p>
      )}

      <ToastContainer />
    </div>
  );
};

export default PalletScanSelection;
